import { createContext, useContext, ReactChild } from "react";

import { parse } from "cookie";

export const DEFAULT_LANGUAGE = "en";

export const LanguageContext = createContext(DEFAULT_LANGUAGE);

export function useLanguage() {
    return useContext(LanguageContext);
}

export type CookieLanguageProviderProps = {
    readonly children?: ReactChild;
};

export const CookieLanguageProvider = ({
    children
}: CookieLanguageProviderProps) => {
    const { lang = DEFAULT_LANGUAGE } = parse(document.cookie);
    return (
        <LanguageContext.Provider value={lang}>
            {children}
        </LanguageContext.Provider>
    );
};

export type StaticLanguageProviderProps = {
    readonly language: string;
    readonly children?: ReactChild;
};

export const StaticLanguageProvider = ({
    language,
    children
}: StaticLanguageProviderProps) => {
    return (
        <LanguageContext.Provider value={language}>
            {children}
        </LanguageContext.Provider>
    );
};
